import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';

import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/el-var.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import '@/assets/style/maia/index.scss'; // 自定义element-plus主题
import '@/assets/style/index.scss';
// 导航组件
// @ts-ignore
import LayoutComponent from '@longfor/vue3-layout/dist/index.mjs'
import '@longfor/vue3-layout/dist/style.css'

import components from '@/components';
// eslint-disable-next-line import/no-unresolved
import 'virtual:svg-icons-register'; // svg注册器
// eslint-disable-next-line import/no-unresolved
import { registerSW } from 'virtual:pwa-register';
import directives from '@/directives'; // 自定义全局指令

import App from './App.vue';
import router from './router';
import store from './store';

registerSW({
  // 每小时检查一次
  // eslint-disable-next-line no-return-await
  onRegistered: (r: any) => r && setInterval(async () => await r.update(), 3600000),
  // 注册失败则报错到 console
  onRegisterError: (error: any) => console.error(error),
});

// app
const app = createApp(App);
app
  .use(store)
  .use(createPinia())
  .use(router)
  .use(ElementPlus)
  .use(LayoutComponent)
  .use(components)
  .use(directives)
  .mount('#app');
